import * as React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { toast } from "sonner";

import { useAuthStore } from "@/shared/lib/auth-store";

export function AdminRoute(): JSX.Element {
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);

  React.useEffect(() => {
    if (token && user && !user.is_admin) {
      toast.error("Доступ только для администратора");
    }
  }, [token, user]);

  if (!token) return <Navigate to="/login" replace />;
  if (user && !user.is_admin) return <Navigate to="/" replace />;
  return <Outlet />;
}
